
















import { isNumber } from "lodash";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Card, { NextCardDirection } from "./Card.vue";
import Control from "./Control.vue";

@Component({ components: { Card, Control } })
export default class HabitabilityCard extends Vue {
  @Prop({ required: true })
  private nextCardDirection: NextCardDirection;

  @Prop({ required: true })
  private pointerAnimationDuration: number;

  @Prop({ required: true })
  private habitability: number;

  private get minHabitability() {
    return 0;
  }

  private get maxHabitability() {
    return 100;
  }

  private isValidHabitability(habitability: number) {
    return isNumber(habitability)
      && habitability >= this.minHabitability
      && habitability <= this.maxHabitability;
  }
}
